<template>
  <div id="company_view">
    <div class="headline">
      <div class="title">{{$t('company.COMPANY_DESCRIPTION')}}</div>
    </div>
    <!-- <div class="navbar">
      <div 
        class="route" 
        @click="onSwiper(0)"
        :style="{
          'background': currentIndex === 0 ? '#13122f' : '#fff',
          'color': currentIndex === 0 ? '#fff' : '#13122f'
          }"
      >
        {{$t('company.ABOUT_US')}}
      </div>
      < <div 
        class="route" 
        @click="onSwiper(1)"
        :style="{
            'background': currentIndex === 1 ? '#13122f' : '#fff',
            'color': currentIndex === 1 ? '#fff' : '#13122f'
        }"
      >
        {{$t('company.JOIN_US')}}
      </div>
      <div 
        class="route" 
        @click="onSwiper(2)"
        :style="{
              'background': currentIndex === 2 ? '#13122f' : '#fff',
              'color': currentIndex === 2 ? '#fff' : '#13122f'
        }"
      >
        {{$t('company.CONTACT_US')}}
      </div> -->
    <!-- </div> -->
     <div class="swiper">
      <div class="swiper_content">
        <div class="swiper_item" ref="swiperRef">
          <AboutUsView />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, onActivated } from 'vue'
import useSwiper from '@/utils/useSwiper'
import AboutUsView from './AboutUsView.vue'
import Mitt from "@/utils/mitt";
import routerHash from "@/constant/router_hash";

const MAX_INDEX = 2
const unit = 33.33

const swiperRef = ref<HTMLDivElement | null>(null)

const onSwiper = (index:number) => currentIndex.value = index
const { currentIndex } = useSwiper(unit, MAX_INDEX)

onMounted(() => {
  Mitt.on(routerHash.CONTACT_US, () => {
    swiperRef.value!.scrollIntoView(true)
  })
})

onUnmounted(() => {
  Mitt.off(routerHash.CONTACT_US)
})

onActivated(() => window.scrollTo({ top: 0 }))
</script>

<style lang="less" scoped>
#company_view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  animation: fadeIn 1s;
  animation-fill-mode: forwards;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .headline {
    width: 100%;
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30rem;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('@/assets/company/company_thumbnail.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    
    .title {
      max-width: 45rem;
      font-size: var(--primary-title);
      margin-bottom: 1rem;
      overflow: hidden;
      text-align: center;
      margin-top: 0.75rem;
      line-height: 3.8rem;
      color: #fff;
      animation:  fadeIn 1s 0.5s forwards;
      opacity: 0;
      font-weight: 700;
      overflow: hidden;
    }

    .describe {
      font-size: var(--primary-text);
      color: #fff;
      animation:  fadeIn 1s 0.5s forwards;
      opacity: 0;
    }
  }

  .navbar {
    margin: 4rem auto;
    width: 100%;
    max-width: var(--view-max-width);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
  }

   .swiper {
      width: 100%;
      overflow-x: hidden;

    &_content {
      display: flex;
      width: 100%;
      transition: all 0.5s;
      gap: 1px;

      .swiper_item {
        width: 100%;
      }
    }
  }
}
</style>